<div cdkDrag [cdkDragData]="data()" [cdkDragDisabled]="!draggable()">
  <div
    class="relative flex gap-2 p-4 pr-2.5 overflow-hidden bg-white hover:cursor-pointer before:absolute before:inset-y-0 before:start-0 before:w-0.75 before:transition-colors [.active]:before:bg-primary-700 hover:not-[.active]:before:bg-gray-300"
    [class]="{
      active: selected(),
    }"
    (click)="selectionChange.emit()"
    role="presentation"
  >
    @if (draggable()) {
      <button mat-icon-button class="inline-flex! size-8! p-1! -ml-2" cdkDragHandle>
        <mat-icon>drag_handle</mat-icon>
      </button>
    }

    <div class="flex gap-1 flex-auto min-w-0">
      <button
        mat-icon-button
        class="inline-flex! size-8! p-1! shrink-0"
        [matTooltip]="isTtsPlaying() ? 'Spraak stoppen' : 'Spraak afspelen'"
        (click)="handleTtsPlayback($event)"
      >
        <mat-icon>{{ isTtsPlaying() ? 'stop' : 'play_arrow' }}</mat-icon>
      </button>

      <div class="flex flex-auto gap-1 text-sm my-auto min-w-0">
        @if (index()) {
          <span>{{ index() }}.</span>
        }
        <span class="break-words flex-auto min-w-0" [innerHTML]="data().value | highlightVariables"></span>
      </div>
    </div>

    <div class="flex"></div>
  </div>
</div>
